export default '/pricing/windows-site';
